import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TrackingService } from 'src/app/services/tracking.service';
import { Constant } from 'src/app/constants/constant';
import { WebsocketService } from 'src/app/services/websocket.service';
//import { Geolocation, GeolocationOptions, Geoposition } from '@ionic-native/geolocation/ngx';
import { ConfigServiceService } from 'src/app/services/config-service.service';

declare var google:any;

@Component({
  selector: 'calsoft-track-shipment',
  templateUrl: './track-shipment.component.html',
  styleUrls: ['./track-shipment.component.scss']
})
export class TrackShipmentComponent implements OnInit {
  data: any;
  salesFlatShipment: any=[];
  trackValues: any;
  type: void;
  @ViewChild('mapElement') mapNativeElement!: ElementRef;
  directionsService: any;
  directionsDisplay: any;
  map: any;
  latitude: number;
  longitude: number;
  apikey: string;
  duration: any;
  distance: any;
  displayMap:boolean;
  deliveryUserId:any;
  deliveryUserLat: any;
  deliveryUserLong: any;
  trackStatus:any;
  shippingId: any;
  latitudeCustomer: any;
  longitudeCustomer: any;
  storeData: any;
  locationSubscription: any;
  serverMapApi: any;
  wareLatitude:any;
  wareLongitude:any;
  orderMsg:boolean;
  orderMsgErr:any;
  constructor(private dialogRef: MatDialogRef<TrackShipmentComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialog: MatDialog, public trackingService: TrackingService,
    public websocket: WebsocketService, private configService: ConfigServiceService,) { 
    this.data = data;
    this.getConfigData();
    this.apikey = 'AIzaSyCftpDvToSO93BQUVr29yqQDhqneMaAxOk';
    this.liveTrackingMsg();
    this.orderMsg = false;
    this.orderMsgErr = '';
  }

 
  ngOnInit(): void {
    this.salesFlatShipment = this.data.page;
    this.trackValues = this.data.track;
    this.type = this.data.types;
    this.storeData = this.data.config;
    this.displayMap = false;
    this.latitudeCustomer=this.data.address['latitude'];
    this.longitudeCustomer=this.data.address['longitude'];
    this.wareLatitude = this.data.wareLat;
    this.wareLongitude = this.data.wareLong;    
    console.log(this.salesFlatShipment);

    if(this.salesFlatShipment.length>0){
      this.deliveryUserId = this.salesFlatShipment[0].peopleId;
      this.shippingId = this.salesFlatShipment[0].entityId;
      this.trackStatus = this.salesFlatShipment[0].shippingAssigne.shipingStatus;
  
      this.getDeliveryUser(this.deliveryUserId);
      this.websocket.initializeWebSocketConnection(this.deliveryUserId, this.salesFlatShipment[0].orderId).subscribe(
        res => {
          var result = res;
        },
      );  
  

    }

    else if(this.salesFlatShipment.length == 0){
      this.orderMsgErr = 'No Order Taken !';
    }

    

  }


  close() {
    this.dialog.closeAll()
  }

  //tracking

  ngAfterViewInit(){
    if(this.deliveryUserId){
      this.getDeliveryUser(this.deliveryUserId);
    }

    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key='+this.apikey+'&libraries=places';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.directionsService = new google.maps.DirectionsService;
      this.directionsDisplay = new google.maps.DirectionsRenderer;
        if(this.trackStatus === 'Ongoing' || this.trackStatus === 'Reached'){
          this.startWatchPosition(); 

        }
        else if(this.trackStatus === 'Pending'){
          this.startWatchstoreLocation();
        }
        else if(this.trackStatus === 'Completed'){
          this.orderMsgErr = 'Order Delivered !';
        }
        else if(this.trackStatus === 'New'){
          this.orderMsgErr = 'Order not accepted';
        }        
    };
    document.body.appendChild(script);
  
  
}

startWatchPosition() {
  console.log('customer');
  let options: any = {
    maximumAge: 0,
    timeout: 5000,
    enableHeightAccuracy: false
  };
  
  let style = [
    {
      featureType: 'all',
      elementType: 'all',
      stylers: [
        { saturation: -100 }
      ]
    }
  ];

  navigator.geolocation.getCurrentPosition((resp) => {

    this.latitude = resp.coords.latitude;
    this.longitude = resp.coords.longitude;

    this.map = new google.maps.Map(document.getElementById('map'), {
      zoom: 7,
      center: {lat: this.latitudeCustomer, lng: this.longitudeCustomer},
      scaleControl: false,
      streetViewControl: false,
      zoomControl: false,
      overviewMapControl: false,
      mapTypeControl: false,
      mapTypeId: 'SwiggyClone', // Use the identifier as a string, not a constructor
      mapTypeControlOptions: {
       mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'SwiggyClone']
      }
    });

    var mapType = new google.maps.StyledMapType(style, { name: 'Grayscale' });
    this.map.mapTypes.set('SwiggyClone', mapType);
  
    // Set the map to use the custom map type
    this.map.setMapTypeId('SwiggyClone');

   // this.latitude = resp.coords.latitude;
   // this.longitude = resp.coords.longitude;

      this.directionsDisplay.setMap(this.map);        
      console.log(this.deliveryUserLat+this.deliveryUserLong);
      console.log(this.latitudeCustomer+this.longitudeCustomer);          
  
      this.calculateAndDisplayRoute(this.latitudeCustomer, this.longitudeCustomer, this.deliveryUserLat, this.deliveryUserLong);
/*
      let options : GeolocationOptions = {
        enableHighAccuracy: true,
        maximumAge: 3000, timeout: 4000
      };
  
      this.geolocation.watchPosition(options).subscribe((data:any) => {
        this.calculateAndDisplayRoute(this.latitudeCustomer, this.longitudeCustomer, this.deliveryUserLat, this.deliveryUserLong);
    });
*/

  },(error) => {
    console.log('Error gettinglal location' + JSON.stringify(error));
  },options);
}


startWatchstoreLocation(){
  console.log('stores');
  let options: any = {
    maximumAge: 0,
    timeout: 5000,
    enableHeightAccuracy: false
  };
  
  let style = [
    {
      featureType: 'all',
      elementType: 'all',
      stylers: [
        { saturation: -100 }
      ]
    }
  ];

  this.map = new google.maps.Map(document.getElementById('map'), {
    zoom: 7,
    center: {lat: this.deliveryUserLat, lng: this.deliveryUserLong},
    scaleControl: false,
    streetViewControl: false,
    zoomControl: false,
    overviewMapControl: false,
    mapTypeControl: false,
    mapTypeId: 'SwiggyClone', // Use the identifier as a string, not a constructor
    mapTypeControlOptions: {
     mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'SwiggyClone']
    }
  });

  var mapType = new google.maps.StyledMapType(style, { name: 'Grayscale' });
  this.map.mapTypes.set('SwiggyClone', mapType);

  // Set the map to use the custom map type
  this.map.setMapTypeId('SwiggyClone');

 // this.latitude = resp.coords.latitude;
 // this.longitude = resp.coords.longitude;

    this.directionsDisplay.setMap(this.map);  
    this.calculateAndDisplayRoute(this.deliveryUserLat, this.deliveryUserLong, this.wareLatitude, this.wareLongitude);
/*
    let option : GeolocationOptions = {
      enableHighAccuracy: true,
      maximumAge: 3000, timeout: 4000
    };

    this.geolocation.watchPosition(option).subscribe((data:any) => {
      this.calculateAndDisplayRoute(this.deliveryUserLat, this.deliveryUserLong, this.storeData.supplierLatitude, this.storeData.supplierLongitude);
  });
*/

}



  calculateAndDisplayRoute(lat, long, lat2, long2){
    const that = this;
    const origin = new google.maps.LatLng(lat, long);
    const destination = new google.maps.LatLng(lat2, long2);
  
    this.directionsService.route({
      origin: origin,
      destination: destination,
      travelMode: 'DRIVING'
    }, (response, status) => {
      if (status === 'OK') {
        that.directionsDisplay.setDirections(response);
  
        // that.addMarker(origin, 'https://mysmartapps.in/img/mansion.png');
        // that.addMarker(destination, 'https://mysmartapps.in/img/delivery-boy1.png'); 
  
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
    this.calculateDistanceMatrix(lat, long, lat2, long2);
  
  }

  addMarker(position, iconUrl) {
    new google.maps.Marker({
      position: position,
      map: this.map,
      icon: iconUrl, // Custom icon URL
      title: 'Location' // Optional title
    });
  }

  calculateDistanceMatrix(lat, long, lat2, long2) {
    const origin = new google.maps.LatLng(lat, long);
    //const destination = new google.maps.LatLng(12.95671, 80.24829);
   // const origin = new google.maps.LatLng(12.965902392887357, 25068579312686);
    const destination = new google.maps.LatLng(lat2, long2);
    
    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix({
      origins: [origin],
      destinations: [destination],
      travelMode: 'DRIVING',
    }, (response: any, status: any) => {
      if (status === 'OK' && response.rows.length > 0) {
        this.duration = response.rows[0].elements[0].duration.text;
        this.distance = response.rows[0].elements[0].distance.text;
        const distanceInMeters = response.rows[0].elements[0].distance.value;
        const distanceInKilometers = distanceInMeters / 1000;
        console.log(distanceInKilometers);

      } else {
        console.error('Error fetching Distance Matrix:', status);
      }
    });
  }


  getDeliveryUser(uid) {
        let id =  uid;
    this.trackingService.trackLocation(id).subscribe((res) => {

      this.deliveryUserLat = res['latitude'];
      this.deliveryUserLong = res['longitude']; 
      console.log(this.deliveryUserLong)     
      },
      (error) => {
        console.log(error)
      }
    )
  }


  liveTrackingMsg() {
    
    this.websocket.getObservableMsg().subscribe((data) => {
    //*  console.log(data);

      // Use a regular expression to match latitude and longitude
      const regex = /(-?\d+\.\d+),\s*(-?\d+\.\d+)/;
      const matches = data.match(regex);

      if (matches) {
        this.deliveryUserLat = Number(matches[1]);
        this.deliveryUserLong = Number(matches[2]);

        console.log('Latitude:', this.deliveryUserLat);   // Outputs: Latitude: 12.9007616
        console.log('Longitude:', this.deliveryUserLong);  // Outputs: Longitude: 80.0653312
      } else {
        console.log('Coordinates not found');
      }

    });
  }
  
  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        data => {
          this.serverMapApi = data.googleApi;
          console.log(this.serverMapApi);
        }, error => {

        }
      );
    }
}
